import Images from "@/data/images.json";

const app = {
  state: {
    activeImageIndex: 0,

    capturedImage: null,
    markedImage: null,
    images: Images,

    captureSize: {
      width: 1024,
      height: 1024
    }
  },
  mutations: {
    SET_ACTIVE_IMAGE_INDEX(state, value) {
      state.activeImageIndex = value;
    },

    SET_CAPTURED_IMAGE(state, value) {
      state.capturedImage = value;
    },
    SET_MARKED_IMAGE(state, value) {
      state.markedImage = value;
    }
  },
  actions: {
    setActiveImageIndex({ commit }, value) {
      commit("SET_ACTIVE_IMAGE_INDEX", value);
    },

    setCapturedImage({ commit }, value) {
      commit("SET_CAPTURED_IMAGE", value);
    },
    setMarkedImage({ commit }, value) {
      commit("SET_MARKED_IMAGE", value);
    }
  },
  getters: {
    getActiveImageIndex(state) {
      return state.activeImageIndex;
    },

    getActiveImage(state) {
      return state.images[state.activeImageIndex];
    },

    getCellsToIdentify(state) {
      return state.images[state.activeImageIndex].cellsToIdentify;
    },

    getFeaturesToIdentify(state) {
      return state.images[state.activeImageIndex].featuresToIdentify;
    },
    getAdditionalInfo(state) {
      return state.images[state.activeImageIndex].additionalInfo;
    },

    getImages(state) {
      return state.images;
    },

    getCaptureSize(state) {
      return state.captureSize;
    },
    getCapturedImage(state) {
      return state.capturedImage;
    },
    getMarkedImage(state) {
      return state.markedImage;
    }
  }
};

export default app;
